import { render, staticRenderFns } from "./activity-list-sms.vue?vue&type=template&id=4cb2dedc&scoped=true"
import script from "./activity-list-sms.vue?vue&type=script&lang=js"
export * from "./activity-list-sms.vue?vue&type=script&lang=js"
import style0 from "./activity-list-sms.vue?vue&type=style&index=0&id=4cb2dedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2dedc",
  null
  
)

export default component.exports